import './Style/Footer.css'
export default function Footer(){
    const currentYear=new Date().getFullYear();
    return(
        <>
        <div className='Footer'>
            <p className='FooterText'> © {currentYear} mithulcrafts</p>
        </div>
        </>
    )
}